import ComingSoonPage from "../../components/ComingSoonPage";
import AppShell from '../../components/AppShell';

export default function WikiForge() {
  return (
    <AppShell>
      <div className="lg:col-span-8 space-y-6 text-center">
    <ComingSoonPage
      appName="Wiki Forge AI"
      teaser="Build searchable, smart wikis from scattered content using AI."
      imageSrc="/images/coming-soon/wikiforge.png"
    />
    </div>
    </AppShell>
  );
}

